export const GET_CWS_INIT_DATA_INIT = 'GET_CWS_INIT_DATA_INIT';
export const GET_CWS_INIT_DATA_SUCCESS = 'GET_CWS_INIT_DATA_SUCCESS';
export const GET_CWS_INIT_DATA_FAILURE = 'GET_CWS_INIT_DATA_FAILURE';
export const MARKET_PLACE_RETURN = 'MARKET_PLACE_RETURN';
export const NON_MARKET_PLACE_RETURN = 'NON_MARKET_PLACE_RETURN';